import { render, staticRenderFns } from "./MTrackingMatrixOrStatus.vue?vue&type=template&id=406d4f0b&lang=pug&"
import script from "./MTrackingMatrixOrStatus.vue?vue&type=script&lang=js&"
export * from "./MTrackingMatrixOrStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports